import { inject, Injectable } from '@angular/core';
import { Select, Store } from '@ngxs/store';
import {
  ClearRepliesByParentId, CloseTextarea,
  DeleteComment, DeleteCommentReply,
  GetCommentsByParentId,
  GetCommentsByRecordId, OpenTextarea, PostComment, PostReply,
  VoteComment,
} from './comments.actions';
import { CommentsState } from './comments.state';
import { Observable } from 'rxjs';
import { Comment } from '../../services/comments/models/comment.model';
import { EditingFacade } from '../../../_core/state/dialogs/editing/editing.facade';

@Injectable({
  providedIn: 'root'
})
export class CommentsFacade {
  private readonly store = inject(Store);
  private readonly editingFacade = inject(EditingFacade);

  @Select(CommentsState.comments) comments$: Observable<Comment[]>;
  @Select(CommentsState.commentsCount) commentsCount$: Observable<number>;
  @Select(CommentsState.lastEvaluatedKey) lastEvaluatedKey$: Observable<string | null>;
  @Select(CommentsState.isLoading) isLoading$: Observable<boolean>;
  @Select(CommentsState.isLoadingReplies) isLoadingReplies$: Observable<string[]>;
  @Select(CommentsState.isCreatingComment) isCreatingComment$: Observable<string[]>;
  @Select(CommentsState.isCreatingReplies) isCreatingReplies$: Observable<string[]>;
  @Select(CommentsState.openTextarea) openTextarea$: Observable<string>;

  getCommentsByRecordId(recordId: string) {
    this.store.dispatch(new GetCommentsByRecordId(recordId));
  }

  getCommentsByParentId(recordId: string, parentId: string, lastEvaluatedKey: string | null = null) {
    this.store.dispatch(new GetCommentsByParentId(recordId, parentId, lastEvaluatedKey));
  }

  postComment(recordId: string, userId: string, comment: string) {
    this.store.dispatch(new PostComment(recordId, userId, comment));
  }

  postReply(recordId: string, userId: string, comment: string, parentId: string, rootCommentId: string, replyUserId: string) {
    this.store.dispatch(new PostReply(recordId, userId, comment, parentId, rootCommentId, replyUserId))
  }

  clearRepliesByParentId(parentId: string) {
    this.store.dispatch(new ClearRepliesByParentId(parentId));
  }

  voteComment(recordId: string, parentId: string, userId: string, like: boolean, rootCommentId?: string) {
    this.store.dispatch(new VoteComment(recordId, parentId, userId, like, rootCommentId));
  }

  deleteComment(commentId: string) {
    this.store.dispatch(new DeleteComment(commentId));
  }

  deleteReply(commentId: string, rootCommentId: string) {
    this.store.dispatch(new DeleteCommentReply(commentId, rootCommentId));
  }

  openTextarea(id: string) {
    this.editingFacade.setEditing(true);
    this.store.dispatch(new OpenTextarea(id));
  }

  closeTextarea() {
    this.editingFacade.setEditing(false);
    this.store.dispatch(new CloseTextarea());
  }
}
